import { observable } from 'mobx'
import { Model, type ModelProps } from '@/infra/model'
import type { Document } from '@/features/documents/Document'
import { DocumentType } from '@/features/documents/DocumentType'

/**
 * Props for {@link DocumentSupportingItemInput}.
 */
export type DocumentSupportingItemInputProps =
  ModelProps<DocumentSupportingItemInput> & { type: 'Document' }

/**
 * Supporting item input for documents.
 */
export class DocumentSupportingItemInput extends Model<DocumentSupportingItemInput> {
  @observable accessor documentType = DocumentType.none
  @observable accessor documents: Document[] = []
}
